module.exports = __webpack_public_path__ + "img/open-tri.19418ce6.svg";